<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col w-full mb-6">
                <h3 class="text-primary">{{ $t('dashboard.bookDetails') }}</h3>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">{{ $t('library.category') }}</label>
                <v-select class="w-full" v-model="bookInfo.categoryId" :options="categoryOptions"
                          :reduce="option => option.value"
                          v-validate="'required'" name="category" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('category') }}</span>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label required">{{ $t('library.bookTitle') }}</label>
                <vs-input class="w-full" v-model="bookInfo.title" v-validate="'required'" name="bookTitle"></vs-input>
                <span class="text-danger text-sm">{{ errors.first('bookTitle') }}</span>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                <label class="vs-input--label">{{ $t('library.languageCode') }}</label>
                <v-select class="w-full" v-model="bookInfo.languageCode" :options="languageOptions"
                          :reduce="option => option.value"
                          v-validate="''" name="languageCode" :clearable="false">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mt-2">
                <label class="vs-input--label">{{ $t('library.color') }}</label>
                <vs-input class="colorInput w-full" v-model="bookInfo.color" type="color"></vs-input>
            </div>
            <div class="vx-col md:w-2/3 w-full md:mt-0 mt-2">
                <label class="vs-input--label">{{ $t('library.description') }}</label>
                <vs-textarea class="w-full" v-model="bookInfo.description"
                             name="categoryDescription"></vs-textarea>
                <span class="text-danger text-sm">{{ errors.first('categoryDescription') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-8">
                <div class="text-center mb-2">
                    <h4>{{ $t('menuOrganization.coverImage') }}</h4>
                </div>
                <div class="flex justify-center">
                    <div class="file-upload flex justify-center" @dragover="dragoverImage" @dragleave="dragleaveImage"
                    @drop="dropImage">
                    <input ref="imageUpload" type="file" id="imageUpload" accept="image/*"
                           class="hidden" @change="uploadImage()">
                    <div class="" v-if="imageFile.length === 0">
                        <div class="text-center">
                            <feather-icon icon="ImageIcon" svgClasses="h-10 w-10 text-primary"/>
                        </div>
                        <div class="text-center button-upload">
                            <vs-button @click="$refs.imageUpload.click()">{{ $t('menuOrganization.chooseAPhoto') }}</vs-button>
                        </div>
                        <div class="text-center mt-4">
                            <label class="file-label text-primary">
                                <div v-if="isDraggingImage">{{ $t('menuOrganization.releaseToDropTheFileHere') }}</div>
                                <div v-else>{{ $t('menuOrganization.dropFilesHere') }}</div>
                            </label>
                            <span><span class="text-md text-danger">*</span>{{ $t('menuOrganization.onlyFilesOfThisFormatAreSupported') }}<span
                                class="text-primary">{{ $t('menuOrganization.photo') }}</span><span
                                class="text-md text-danger">*</span></span>
                        </div>
                    </div>
                    <div v-else class="w-full">
                        <div class="text-center">
                            <vx-tooltip class="" :text="$t('button.delete')" position="top" color="danger">
                                <feather-icon icon="XCircleIcon" svgClasses="h-5 w-5 text-danger"
                                              @click="deleteImage"/>
                            </vx-tooltip>
                        </div>
                        <div class="text-center">
<!--                            <svg data-v-5e4e33b8="" xmlns="http://www.w3.org/2000/svg" width="100px" height="100px"-->
<!--                                 viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"-->
<!--                                 stroke-linecap="round" stroke-linejoin="round"-->
<!--                                 class="feather feather-file-text text-primary">-->
<!--                                <path data-v-5e4e33b8=""-->
<!--                                      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>-->
<!--                                <polyline data-v-5e4e33b8="" points="14 2 14 8 20 8"></polyline>-->
<!--                                <line data-v-5e4e33b8="" x1="16" y1="13" x2="8" y2="13"></line>-->
<!--                                <line data-v-5e4e33b8="" x1="16" y1="17" x2="8" y2="17"></line>-->
<!--                                <polyline data-v-5e4e33b8="" points="10 9 9 9 8 9"></polyline>-->
<!--                            </svg>-->
                            <img class="imagePreview" :src="imageFile[0].src" alt="" @load="$vs.loading.close()">
                        </div>
                        <div class="text-center">
                            <span style="white-space: nowrap; text-overflow: ellipsis; width: 150px; overflow: hidden; display: inline-block">{{ imageFile[0].name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-8">
            <div class="text-center mb-2">
                <h4>{{ $t('menuOrganization.contentFiles') }}</h4>
            </div>
            <div class="flex justify-center">
                <div class="file-upload" @dragover="dragoverFile" @dragleave="dragleaveFile" @drop="dropFile">
                    <input ref="fileUpload" type="file" id="fileUpload" accept=".doc, .docx, .pdf, .epub"
                           class="hidden" @change="uploadFile()">
                    <div class="" v-if="files.length === 0">
                        <div class="text-center">
                            <feather-icon icon="UploadIcon" svgClasses="h-10 w-10 text-primary"/>
                        </div>
                        <div class="text-center button-upload">
                            <vs-button @click="$refs.fileUpload.click()">{{ $t('menuOrganization.selectedFile') }}</vs-button>
                        </div>
                        <div class="text-center mt-4">
                            <label class="file-label text-primary">
                                <div v-if="isDragging">{{ $t('menuOrganization.releaseToDropTheFileHere') }}</div>
                                <div v-else>{{ $t('menuOrganization.dropFilesHere') }}</div>
                            </label>
                            <span><span class="text-md text-danger">*</span>{{ $t('menuOrganization.onlyFilesOfThisFormatAreSupported') }} <span
                                class="text-primary">.doc, .docx, .pdf, .epub</span><span
                                class="text-md text-danger">*</span></span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="text-center">
                            <vx-tooltip class="" :text="$t('button.delete')" position="top" color="danger">
                                <feather-icon icon="XCircleIcon" svgClasses="h-5 w-5 text-danger" @click="deleteFile"/>
                            </vx-tooltip>
                        </div>
                        <div class="text-center">
                            <svg data-v-5e4e33b8="" xmlns="http://www.w3.org/2000/svg" width="100px" height="100px"
                                 viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"
                                 stroke-linecap="round" stroke-linejoin="round"
                                 class="feather feather-file-text text-primary">
                                <path data-v-5e4e33b8=""
                                      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline data-v-5e4e33b8="" points="14 2 14 8 20 8"></polyline>
                                <line data-v-5e4e33b8="" x1="16" y1="13" x2="8" y2="13"></line>
                                <line data-v-5e4e33b8="" x1="16" y1="17" x2="8" y2="17"></line>
                                <polyline data-v-5e4e33b8="" points="10 9 9 9 8 9"></polyline>
                            </svg>
                        </div>
                        <div class="text-center">
                            <span>{{ files[0].name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col w-full">
            <div class="flex flex-wrap justify-end mt-6">
                <vs-button class="ml-auto" @click="saveChanges" :disabled="!validateForm">
                    {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                </vs-button>
                <vs-button class="ml-4" type="border" color="warning" @click="$router.go(-1)" v-if="!this.isUpdate">
                    {{ $t('button.back') }}
                </vs-button>
                <vs-button class="ml-4" type="border" color="danger" @click="closePopup" v-else>
                    {{ $t('button.close') }}
                </vs-button>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
    name: "DetailsBook",
    components: {
        vSelect,
    },
    props: {
        bookId: {
            default: null,
            type: Number
        }
    },
    computed: {
        filtered() {
            return this.categoryOptions;
        },
        paginated() {
            return this.filtered.slice(0, this.limit);
        },

        validateForm() {
            return !this.errors.any()
        },
    },

    data() {
        return {
            categoryOptions: [],
            bookInfo: {
                categoryId: null,
                title: null,
                description: null,
                languageCode: null,
                color: null,
            },
            isUpdate: false,
            isDragging: false,
            files: [],
            languageOptions: [],
            isDraggingImage: false,
            imageFile: []
        }
    },

    async created() {
        await this.getCategory();
        await this.getLanguage();
        if (this.bookId) {
            this.isUpdate = true;
            await this.getDetailsBook();
        }

    },

    methods: {
        getCategory() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();

                this.$crm.post('/library/category/find-by-condition', {}).then(res => {
                    this.$vs.loading.close();
                    resolve(res);
                    if (res.data.content && res.data.content.length > 0) {
                        this.categoryOptions = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.title
                            }
                        })
                    } else {
                        this.categoryOptions = [];
                    }
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getLanguage() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get('/setting/organization-language/find-by-organization-id').then(res => {
                    this.$vs.loading.close();
                    resolve();
                    if (res.data && res.data.length > 0) {
                        this.languageOptions = res.data.map(el => {
                            return {
                                value: el.code,
                                label: el.name,
                            }
                        })
                    } else {
                        this.languageOptions = [];
                    }
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;

            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.files.length === 0) {
                return this.$vs.notify({
                    title: 'Lỗi!',
                    text: 'Trường tệp là bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if (this.imageFile.length === 0) {
                return this.$vs.notify({
                    title: 'Lỗi!',
                    text: 'Trường ảnh bìa là bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            let formData = new FormData(), config = {};
            config = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            };
            const blob = new Blob([JSON.stringify(this.bookInfo)], {type: 'application/json'});
            formData.append('dto', blob);
            if (!this.files[0].id) formData.append('files', this.files[0]);
            if (!this.imageFile[0].id) formData.append('imageFiles', this.imageFile[0]);

            let url = this.isUpdate ? `/library/item/update/${this.bookId}` : '/library/item/create';

            this.$vs.loading();
            this.$crm.post(url, formData, config).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật' : 'Tạo mới'} đầu sách thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                if (!this.isUpdate) {
                    this.$router.push('/user/manage-book').catch(() => {
                    });
                } else {
                    this.closePopup();
                    this.$store.commit('UPDATE_BOOK', true);
                }
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        closePopup() {
            this.$eventBus.$emit("close-popup-details-book", {});
        },

        getDetailsBook() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/library/item/find-by-id/${this.bookId}`).then(async res => {
                    this.$vs.loading.close();
                    this.bookInfo = res.data;
                    this.bookInfo.categoryId = res.data.libraryCategory.id;
                    let files = this.bookInfo.fileManagers.find(el => el.fileManagerType === 4),
                        images = this.bookInfo.fileManagers.find(el => el.fileManagerType === 1);
                    if (files) {
                        let blob = await this.getBlobFromUrl(files);
                        let file = new File([blob], files.name, {type: files.fileType})
                        file['id'] = files.id;
                        this.files.push(file);
                    }

                    if (images) {
                        this.$vs.loading();
                        let blob = await this.getBlobFromUrl(images);
                        let image = new File([blob], images.name, {type: images.fileType})
                        image['id'] = images.id;
                        image['src'] = images.url;
                        this.imageFile.push(image);
                    }
                    resolve(res);
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi!',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        uploadFile() {
            let file = this.$refs.fileUpload.files[0];
            this.$refs.fileUpload.value = null;
            if (file.size > 200000000) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Kích thước tệp không được vượt quá 200MB',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }
            if (!this.isCheckFile(file)) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Chỉ hỗ trợ tệp có định dạng .doc, .docx, .pdf, .epub',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }
            this.files.push(file);
            this.$refs.fileUpload.value = null;
        },

        isCheckFile(file) {
            return /\.(doc|docx|pdf|epub)$/.test(file.name)
        },

        dragoverFile(e) {
            if (this.files.length === 0) {
                e.preventDefault();
                this.isDragging = true;
            }
        },
        dragleaveFile() {
            if (this.files.length === 0) {
                this.isDragging = false;
            }
        },
        dropFile(e) {
            if (this.files.length === 0) {
                e.preventDefault();
                this.$refs.fileUpload.files = e.dataTransfer.files;
                this.uploadFile();
                this.isDragging = false;
            }
        },

        deleteFile() {
            this.files = [];
        },

        uploadImage() {
            let file = this.$refs.imageUpload.files[0];
            this.$refs.imageUpload.value = null;
            if (file.size > 20000000) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Kích thước tệp không được vượt quá 20MB',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }
            if (!this.isCheckImage(file)) {
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: 'Định dạng tệp không phù hợp!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            }
            file['src'] = URL.createObjectURL(file);
            this.imageFile.push(file);
            this.$refs.imageUpload.value = null;
        },

        isCheckImage(file) {
            const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
            const extension = file.name.split('.').pop().toLowerCase();
            return imageExtensions.includes(extension);
        },

        dragoverImage(e) {
            if (this.imageFile.length === 0) {
                e.preventDefault();
                this.isDraggingImage = true;
            }
        },
        dragleaveImage() {
            if (this.imageFile.length === 0) {
                this.isDraggingImage = false;
            }
        },
        dropImage(e) {
            if (this.imageFile.length === 0) {
                e.preventDefault();
                this.$refs.imageUpload.files = e.dataTransfer.files;
                this.uploadImage();
                this.isDraggingImage = false;
            }
        },

        deleteImage() {
            this.imageFile = [];
        },

        getBlobFromUrl(url) {
            return new Promise((resolve, reject) => {
                let request = new XMLHttpRequest();
                request.open('GET', url, true);
                request.responseType = 'blob';
                request.onload = () => {
                    resolve(request.response);
                };
                request.onerror = reject;
                request.send();
            })
        },
    }
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>

<style lang="scss">
.colorInput .vs-input--input.normal {
    padding: 0.1rem !important;
    height: 37.59px;
}

.file-upload {
    width: 350px;
    height: 200px;
    border: dashed 2px rgba(var(--vs-primary), 1);
    border-radius: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .button-upload button {
        border-radius: 1.5rem;
    }

    .file-label {
        color: #C0C0C0;
    }

    .imagePreview {
        max-width: 300px;
        max-height: 130px;
    }
}
</style>
